import React from 'react'
import cx from 'classnames'

const Dialog = ({ children, className }) => (
  <div className={cx('dialog', className)}>{children}</div>
)

export default Dialog
